var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBuddyAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Buddy_x5F_Alarm"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      enableBackground: "new"
    },
    d: "M4.964,11.354c-1.097,0-1.985,0.89-1.985,1.985 c0,1.097,0.889,1.986,1.985,1.986c1.096,0,1.984-0.89,1.984-1.986C6.948,12.244,6.06,11.354,4.964,11.354z M8.925,19.816 c-0.218-1.617-1.356-3.155-2.329-3.586C6.3,16.085,5.69,15.902,4.971,15.902c-0.72,0-1.329,0.183-1.627,0.328 c-0.972,0.431-2.111,1.969-2.329,3.586c-0.01,0.115-0.003,0.298,0.198,0.324c0.579,0,2.166,0,3.758,0c1.591,0,3.178,0,3.756,0 C8.929,20.114,8.935,19.932,8.925,19.816z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.877,12.061l-2.113-1.087l0.197-0.387c0.171-0.333,0.534-0.489,0.811-0.347l1.111,0.571 c0.276,0.143,0.363,0.528,0.191,0.862L21.877,12.061z M22.904,15.868c0,1.485-0.73,2.801-1.854,3.603l0.652,1.415 c0,0,0.028,0.253-0.22,0.372c-0.269,0.133-0.457-0.043-0.457-0.043l-0.645-1.35c-0.572,0.271-1.217,0.426-1.895,0.426 s-1.318-0.152-1.895-0.426l-0.642,1.351c0,0-0.192,0.177-0.461,0.043c-0.246-0.12-0.22-0.373-0.22-0.373l0.653-1.415 c-1.121-0.802-1.853-2.117-1.853-3.603c0-2.444,1.977-4.424,4.414-4.424C20.927,11.444,22.904,13.424,22.904,15.868z  M18.489,12.417c-1.9,0-3.44,1.543-3.44,3.449c0,1.903,1.54,3.446,3.44,3.446c1.899,0,3.44-1.543,3.44-3.446 C21.932,13.961,20.391,12.417,18.489,12.417z M20.518,17.943c-0.309,0-1.152,0-2,0s-1.691,0-2,0 c-0.107-0.016-0.11-0.111-0.106-0.174c0.116-0.863,0.724-1.686,1.241-1.914c0.158-0.078,0.482-0.176,0.865-0.176 s0.707,0.098,0.865,0.176c0.518,0.229,1.124,1.051,1.24,1.914C20.628,17.832,20.625,17.93,20.518,17.943z M18.514,15.372 c-0.584,0-1.058-0.476-1.058-1.062s0.474-1.06,1.058-1.06s1.057,0.474,1.057,1.06S19.098,15.372,18.514,15.372z M14.895,11.671 c-0.172-0.332-0.086-0.716,0.191-0.857l1.112-0.569c0.276-0.142,0.64,0.013,0.812,0.345l0.198,0.385l-2.116,1.081L14.895,11.671z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      enableBackground: "new"
    },
    d: "M17.102,8.542l-3.403-1.948c0,0,1.2-0.366,1.536-0.479 c-1.2-1.832-2.592-2.127-4.399-2.142c-2.282,0.064-4.752,1.9-5.743,4.293l-0.087-0.01C4.894,6.512,7.533,2.987,10.819,2.72 c2.18-0.142,4.244,0.183,6.1,2.754c0,0,1.595-0.503,1.298-0.408C18.163,5.35,17.102,8.542,17.102,8.542z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuddyAlarm);
export default __webpack_public_path__ + "static/media/ic_buddy_alarm.454829360009410b903206fcab54a65f.svg";
export { ForwardRef as ReactComponent };